import React, { useCallback } from "react";
import * as Select from "@radix-ui/react-select";
import { graphql, useFragment } from "react-relay";
import { OrgUserEditAccessSelect_workspaces$key } from "./__generated__/OrgUserEditAccessSelect_workspaces.graphql";
import { SelectorValueTrigger } from "./Selector";
import { WorkspaceSelectorContent } from "../../WorkspaceSelector/WorkspaceSelectorContent";
import { Box } from "arkh";

type OrgUserWorkspace = {
  id: string;
  name: string;
  subWorkspaceCount: number;
};

export function OrgUserEditAccessSelect(props: {
  workspaces: OrgUserEditAccessSelect_workspaces$key;
  disabledIds: string[];
  selectedWorkspace: OrgUserWorkspace | undefined;
  onSelectWorkspace: (workspace: OrgUserWorkspace) => void;
}) {
  const workspaces = useFragment(
    graphql`
      fragment OrgUserEditAccessSelect_workspaces on Workspace
      @relay(plural: true) {
        id
        name
        subWorkspaceCount
        ...WorkspaceSelectorContent_workspaces
      }
    `,
    props.workspaces
  );

  const onValueChange = useCallback(
    (value: string) => {
      props.onSelectWorkspace({
        id: value,
        subWorkspaceCount:
          workspaces.find((w) => w.id === value)?.subWorkspaceCount ?? 0,
        name: workspaces.find((w) => w.id === value)?.name ?? "",
      });
    },
    [workspaces, props]
  );

  return (
    <Box spaceHorizontal="small">
      <Select.Root
        value={props.selectedWorkspace?.id}
        onValueChange={onValueChange}
      >
        <SelectorValueTrigger
          valueLabel={props.selectedWorkspace?.name ?? ""}
          mode="large"
        />
        <Select.Portal>
          <WorkspaceSelectorContent
            workspaces={workspaces}
            selectedId={props.selectedWorkspace?.id}
            disabledIds={props.disabledIds}
          />
        </Select.Portal>
      </Select.Root>
    </Box>
  );
}
